/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export interface IapState {
  deferredPurchases: Array<string>;
}

const initialState: IapState = {
  deferredPurchases: [],
};

export const iapSlice = createSlice({
  name: 'iap',
  initialState,
  reducers: {
    iapSubscriptionProcessingDeferred: (
      state,
      action: PayloadAction<object>,
    ) => {
      const stringifiedPurchase = JSON.stringify(action.payload);
      if (!state.deferredPurchases.includes(stringifiedPurchase)) {
        state.deferredPurchases.push(stringifiedPurchase);
      }
    },
    iapSubscriptionProcessingResumed: (
      state,
      action: PayloadAction<object>,
    ) => {
      const stringifiedPurchase = JSON.stringify(action.payload);
      state.deferredPurchases = state.deferredPurchases.filter(
        (sp) => sp !== stringifiedPurchase,
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.deferredPurchases = [];
    });
  },
});

export const {
  iapSubscriptionProcessingDeferred,
  iapSubscriptionProcessingResumed,
} = iapSlice.actions;

export default iapSlice.reducer;
